import React from 'react';

export default function Template() {
  return (
    <div>
      <p>
        Choose “Yes” if the entity qualifies as a U.S. person, additional documentation such as IRS Form W-9 may be
        required.
      </p>
      <p>
        Select “Yes” if your company is registered or incorporated in the United States of America (i.e., has a U.S. Tax
        Identification Number (TIN)). In all other cases, select “No”
      </p>
    </div>
  );
}
